import { Card, CardContent, Typography, Button, Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

interface PropsAlertDisplay {
  titulo: string;
  registro: string;
  acao?: string;
  color: "success" | "warning" | "error";
  acaoCallback?: () => void;
}

export default function AlertDisplay({ titulo, registro, acao, color, acaoCallback }: PropsAlertDisplay) {

  const colorIcon = color === "success" ? "#4caf50" : color === "warning" ? "#ff9800" : "#f44336";

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Card variant="outlined" sx={{ borderLeft: `5px solid ${colorIcon}` }}>
        <CardContent sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box display="flex" flexDirection="column">
            <Box display="flex" alignItems="center" gap={1}>
              {color === "success" ? <CheckCircleIcon sx={{ color: colorIcon }} /> : <WarningAmberIcon sx={{ color: colorIcon }} />}
              <Typography variant="subtitle1" fontWeight="bold">
                {titulo}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              {registro}
            </Typography>
          </Box>
          {acao && <Button variant="outlined" color={color} onClick={acaoCallback}>
            {acao}
          </Button>}
        </CardContent>
      </Card>
    </Box>
  );
}
